import { useRef, useState, useEffect } from "react"
import Slider from "react-slick"
import CouponDrawer from "./CouponDrawer"

const COUPONS = [
    "GIẢM 4%",
    "GIẢM 0.5%",
    "GIẢM 800.000đ",
    "QUÀ TẶNG",
    "GIẢM 100.000đ",
    "TẶNG 1 TÚI",
    "GIẢM 50.000đ",
    "GIẢM 35.000",
]

export default function CouponSlider() {
    const [openDrawer, setOpenDrawer] = useState(false)
    const settings = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 1,
        swipeToSlide: true,
        variableWidth: true,
    }

    useEffect(() => {
        if (openDrawer) {
            document.documentElement.style.overflow = "hidden"
            document.body.style.overflow = "hidden"
        } else {
            document.documentElement.style.overflow = ""
            document.body.style.overflow = ""
        }

        return () => {
            document.documentElement.style.overflow = ""
            document.body.style.overflow = ""
        }
    }, [openDrawer])

    return (
        <div className="MuiBox-root css-120nera">
            <div className="MuiBox-root css-14r5gjr"><span className="styles_headLabel__tKC70">Mã giảm giá có thể sử dụng</span></div>
            <div className="styles_listCouponWrapper__yPH5B MuiBox-root css-ktqgk7">
                <Slider {...settings} className="styles_slider__yU6vN">
                    {COUPONS.map((label, index) => (
                        <div key={index} style={{ width: 125 }}>
                            <button
                                type="button"
                                className="MuiButtonBase-root styles_couponWrapper__ZKKgG"
                            >
                                <div className="styles_coupounPart_container__9BabF flex items-center">
                                    <div className="flex items-center h-[14px] mt-1">{label}</div>
                                </div>
                            </button>
                        </div>
                    ))}
                </Slider>
            </div>
            <div className="MuiBox-root css-6hmvm7"><button onClick={() => setOpenDrawer(true)} className="MuiButtonBase-root MuiButton-root MuiButton-text styles_dFlex_spacing_4__JOtSp styles_buttonAction__dEObZ" type="button"><span className="MuiButton-label">Xem tất cả <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="PlayCircleOutlineOutlinedIcon"><path d="m10 16.5 6-4.5-6-4.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></svg></span><span className="MuiTouchRipple-root"></span></button></div>
            <CouponDrawer
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
            />
        </div>
    )
}

